'use es6';

import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import createReactClass from 'create-react-class';
import UISelectableButton from 'UIComponents/button/UISelectableBox';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H5 from 'UIComponents/elements/headings/H5';
export default createReactClass({
  displayName: "SkeletonTimePicker",
  renderTimePickerButtons: function renderTimePickerButtons() {
    return _toConsumableArray(Array(4)).map(function (value, index) {
      return /*#__PURE__*/_jsx("div", {
        className: "p-y-1 p-right-1",
        children: /*#__PURE__*/_jsx(UISelectableButton, {
          block: true,
          padded: false,
          selected: false,
          className: "time-picker-btn",
          children: /*#__PURE__*/_jsx("div", {
            className: "skeleton"
          })
        })
      }, index);
    });
  },
  renderInputs: function renderInputs() {
    return /*#__PURE__*/_jsx("div", {
      className: "time-list-container",
      children: /*#__PURE__*/_jsx("div", {
        className: "time-list",
        children: this.renderTimePickerButtons()
      })
    });
  },
  render: function render() {
    return /*#__PURE__*/_jsxs("div", {
      className: "time-picker time-picker-skeleton width-100",
      children: [/*#__PURE__*/_jsx(H5, {
        className: "skeleton-text",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "prebook.timePicker.header"
        })
      }), this.renderInputs()]
    });
  }
});